<template>
  <tr class="border-b-1 border-b-gray-600">
    <th>
      <sort-control
        field="systemName"
        :selected="currentSortField === 'systemName'"
        v-on="listeners"
        >System Name</sort-control
      >
    </th>
    <th></th>
  </tr>
</template>
<script>
import SortControl from "@/components/common/tables/SortControl.vue";

export default {
  components: { SortControl },
  props: ["currentSortField"],
  computed: {
    listeners: function() {
      // Vue 3: $listeners merged into $attrs
      return this.$attrs;
    },
  },
};
</script>
